import {
  API_USAGE_ERROR,
  API_USAGE_LOADING,
  API_USAGE_SET,
  LOGOUT,
} from "../types";

/*
    API usage panel (static#9) — GET /api-access/usage.

    Its own slice rather than a field on `apiAccess`, because the two load on
    different schedules: the key status is fetched by the account shell for
    the nav pill, usage only when the API Management page shows the panel.

    `error` is a boolean on purpose. The panel shows one fixed sentence on a
    failure, and `data` is cleared so nothing can render a stale or zero count
    next to it.
*/

const initialState = {
  loading: false,
  error: false,
  data: null,
  // The load whose answer this slice is waiting for. An answer carrying any
  // other id is dropped: a request that was overtaken by a newer one, or that
  // was still in flight at LOGOUT (which resets this to null), must not write
  // its customer's counts into the store.
  requestId: null,
};

export default function apiUsageReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case API_USAGE_LOADING:
      // A new load clears what the last one left, so a revisit shows the
      // loading state rather than old counts or an old error.
      return {
        loading: true,
        error: false,
        data: null,
        requestId: payload.requestId,
      };
    case API_USAGE_SET:
      if (payload.requestId !== state.requestId) return state;
      return { ...state, loading: false, error: false, data: payload.usage };
    case API_USAGE_ERROR:
      if (payload.requestId !== state.requestId) return state;
      return { ...state, loading: false, error: true, data: null };
    case LOGOUT:
      // Same reason as apiAccessReducer: the next customer must not see the
      // previous one's counts while their own request is in flight.
      return initialState;
    default:
      return state;
  }
}
